import { Card, CardBody, CardHeader, Row, Col, Badge, Label, Input, FormGroup } from 'reactstrap';
import { RefreshCcw, CheckCircle, Clock, Layout, DollarSign, MapPin } from 'lucide-react';

const Icons = {
  Layout: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>
  ),
  CheckCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
  ),
  Unlock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>
  ),
  Lock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
  ),
  Maximize: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>
  ),
  DollarSign: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
  ),
  Zap: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
  ),
  Car: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>
  ),
  Trash2: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
  ),
  MapPin: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
  )
};

const Totalizador = ({
  totaisGerais,
  totaisFiltrados,
  paisesOptions = [],
  estadosOptions = [],
  cidadesOptions = [],
  paisSelecionado,
  onPaisChange,
  estadoSelecionado,
  onEstadoChange,
  cidadeSelecionada,
  onCidadeChange,
  feiraRenovada,
  corLivre,
  corPendenteRenovacao,
  corRenovacao,
  corReservado,
  corVendido
}) => {
  
  const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);
  const formatNumber = (val) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(val || 0);

  return (
    <div className="container-fluid py-4 bg-light min-vh-100">
      {/* Cabeçalho */}
      <div className="row mb-4 align-items-center">
        <div className="col">
          <h4 className="fw-bold text-primary m-0 d-flex align-items-center gap-2">
            <Icons.Layout /> TOTAIS GERAIS DO RELATÓRIO
          </h4>
          <p className="text-muted small m-0 italic">Resumo consolidado dos espaços e metragens</p>
        </div>
        <div className="col-auto">
          <div className="bg-white border p-2 px-3 rounded shadow-sm d-flex align-items-center gap-2">
            <div className="text-primary"><Icons.CheckCircle /></div>
            <div>
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '9px' }}>Total de Itens</div>
              <div className="fw-bold h6 m-0">{totaisGerais.totalEspacos}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 1. Status dos Espaços */}
      <div className="mb-4">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div style={{width: '4px', height: '18px', backgroundColor: '#0d6efd', borderRadius: '2px'}}></div>
          <h6 className="fw-bold text-muted text-uppercase mb-0" style={{fontSize: '12px', letterSpacing: '1px'}}>Status dos Espaços</h6>
        </div>
        <div className="row g-3">
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.Layout />} title="Total" value={totaisGerais.totalEspacos} color={"primary"} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.CheckCircle />} title="Vendidos" value={totaisGerais.espacosVendidos} color={corVendido} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.Unlock />} title="Livres" value={totaisGerais.faltam} color={corLivre} />
          </div>
          <div className="col-6 col-md-3">
            <StatCard icon={<Icons.Lock />} title="Reservados" value={totaisGerais.espacosReservados} color={corReservado} />
          </div>

          { feiraRenovada && (
            <>
                <div className="col-6 col-md-3">
                    <StatCard icon={<Icons.Unlock />} title="Pend.Ren." value={totaisGerais.espacosPendenteRenovacao} color={corPendenteRenovacao} />
                </div>
                <div className="col-6 col-md-3">
                    <StatCard icon={<Icons.Lock />} title="Renovados" value={totaisGerais.espacosRenovados} color={corRenovacao} />
                </div>
            </>
          )}
        </div>
      </div>

      {/* 2. Metragem */}
      <div className="mb-4">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div style={{width: '4px', height: '18px', backgroundColor: '#198754', borderRadius: '2px'}}></div>
          <h6 className="fw-bold text-muted text-uppercase mb-0" style={{fontSize: '12px', letterSpacing: '1px'}}>Análise de Metragem (m²)</h6>
        </div>
        <div className="row g-2">
            <div className="col"><MiniCard title="Total" value={formatNumber(totaisGerais.metragemTotal)} theme="primary" /></div>
            <div className="col"><MiniCard title="Vendida" value={formatNumber(totaisGerais.metragemVendida)} theme="success" cor={corVendido}/></div>
            <div className="col"><MiniCard title="Bonificada" value={formatNumber(totaisGerais.metragemBonificada)} theme="secondary" /></div>
            <div className="col"><MiniCard title="Cobrada" value={formatNumber(totaisGerais.metragemCobrada)} theme="primary" /></div>
        </div>
      </div>

      {/* 3. Financeiro e Serviços */}
      <div className="row mb-4">
        <div className="col-lg-7 mb-4 mb-lg-0">
          <div className="card h-100 shadow-sm border-0 rounded-4">
            <div className="card-header bg-transparent border-0 pt-4 px-4">
              <div className="d-flex align-items-center gap-2">
                <div className="bg-success text-white p-2 rounded shadow-sm"><Icons.DollarSign /></div>
                <h6 className="fw-bold mb-0 text-uppercase tracking-wider">Resumo Financeiro</h6>
              </div>
            </div>
            <div className="card-body p-4">
              <div className="pb-4 mb-4 border-bottom">
                <p className="text-muted small fw-bold text-uppercase mb-1">Valor Total Vendido</p>
                <h2 className="fw-bold text-dark mb-0">{formatCurrency(totaisGerais.valorTotalVendido)}</h2>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded border-start border-4 border-primary">
                    <p className="text-muted small fw-bold text-uppercase mb-1">Valor Espaço</p>
                    <h5 className="fw-bold mb-0">{formatCurrency(totaisGerais.valorEspaco)}</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded">
                    <p className="text-muted small fw-bold text-uppercase mb-1">Taxas e Outros</p>
                    <h5 className="fw-bold mb-0">{formatCurrency(totaisGerais.valorEstacionamento + totaisGerais.valorKVA + totaisGerais.valorLimpeza + totaisGerais.valorMerchan)}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5">
          <div className="card h-100 shadow-sm border-0 rounded-4">
            <div className="card-header bg-transparent border-0 pt-4 px-4">
              <div className="d-flex align-items-center gap-2">
                <div className="bg-warning text-white p-2 rounded shadow-sm"><Icons.Zap /></div>
                <h6 className="fw-bold mb-0 text-uppercase tracking-wider">Serviços e Taxas</h6>
              </div>
            </div>
            <div className="card-body p-4 d-flex flex-column gap-3">
              <ServiceRow icon={<Icons.Zap />} color="warning" label="Valor KVA" value={formatCurrency(totaisGerais.valorKVA)} sub={`Qtd: ${totaisGerais.quantidadeKVA} un.`}/>
              <ServiceRow icon={<Icons.Car />} color="primary" label="Estacionamento" value={formatCurrency(totaisGerais.valorEstacionamento)} sub={`Qtd: ${totaisGerais.quantidadeEstacionamento} un.`}/>
              <ServiceRow icon={<Icons.Trash2 />} color="danger" label="Taxa Limpeza" value={formatCurrency(totaisGerais.valorLimpeza)} />
              { totaisGerais.valorMerchan > 0 && (<ServiceRow icon={<Icons.DollarSign />} color="success" label="Merchan" value={formatCurrency(totaisGerais.valorMerchan)} />)}
            </div>
          </div>
        </div>
      </div>

      {/* 4. Filtro Geográfico */}
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-header bg-transparent border-0 pt-4 px-4 d-flex align-items-center gap-2">
          <div className="bg-dark text-white p-2 rounded shadow-sm"><Icons.MapPin /></div>
          <h6 className="fw-bold mb-0 text-uppercase tracking-wider">Localização de Vendas</h6>
        </div>
        
        <div className="card-body p-4">
          <div className="row g-3 mb-4 pb-4 border-bottom border-dashed">
            <div className="col-md-4">
              <label className="small fw-bold text-muted text-uppercase mb-1 d-block">País</label>
              <Input type="select" className="form-select-sm border-2" 
                value={paisSelecionado} 
                onChange={(e) => onPaisChange(e.target.value)}>
                <option value="">Todos os países</option>
                {paisesOptions.map((pais, index) => (<option key={`${pais.sigla}-${index}`} value={pais.sigla}>{pais.nome}</option>))}
              </Input>
            </div>
            <div className="col-md-4">
              <label className="small fw-bold text-muted text-uppercase mb-1 d-block">Estado</label>
              <Input type="select" className="form-select-sm border-2" 
                value={estadoSelecionado} 
                onChange={(e) => onEstadoChange(e.target.value)} 
                disabled={paisSelecionado !== 'BR'}>
                <option value="">Todos os estados</option>
                {estadosOptions.map((estado) => (<option key={estado.sigla} value={estado.sigla}>{estado.nome}</option>))}
              </Input>
            </div>
            <div className="col-md-4">
              <label className="small fw-bold text-muted text-uppercase mb-1 d-block">Cidade</label>
              <Input type="select" className="form-select-sm border-2" 
                value={cidadeSelecionada} 
                onChange={(e) => onCidadeChange(e.target.value)} 
                disabled={!estadoSelecionado}>
                <option value="">Todas as cidades</option>
                {cidadesOptions.map((cidade) => (<option key={cidade.id} value={cidade.nome}>{cidade.nome}</option>))}
              </Input>
            </div>
          </div>
          {totaisFiltrados ? (
            <Row className="text-center g-4">
            <Col md={4}>
                <div className="p-3 rounded-3 bg-light">
                <p className="text-muted small mb-1 fw-bold">CLIENTES NO LOCAL</p>
                <h4 className="text-primary mb-1">{totaisFiltrados.clientes}</h4>
                <Badge color="primary-subtle" className="text-primary border border-primary-subtle">
                    {formatNumber(totaisFiltrados.percentualClientes)}% do total
                </Badge>
                </div>
            </Col>
            <Col md={4}>
                <div className="p-3 rounded-3 bg-light">
                <p className="text-muted small mb-1 fw-bold">ÁREA OCUPADA</p>
                <h4 className="text-success mb-1">{formatNumber(totaisFiltrados.metragem)} m²</h4>
                <Badge color="success-subtle" className="text-success border border-success-subtle">
                    {formatNumber(totaisFiltrados.percentualMetragem)}% da área
                </Badge>
                </div>
            </Col>
            <Col md={4}>
                <div className="p-3 rounded-3 bg-light">
                <p className="text-muted small mb-1 fw-bold">VALOR CONTRATADO</p>
                <h4 className="text-info mb-1">{formatCurrency(totaisFiltrados.valor)}</h4>
                <Badge color="info-subtle" className="text-info border border-info-subtle">
                    {formatNumber(totaisFiltrados.percentualValor)}% da receita
                </Badge>
                </div>
            </Col>
            </Row>
        ) : (
            <div className="text-center py-4 bg-light rounded-3 border border-dashed">
            <p className="text-muted mb-0">Utilize os filtros acima para detalhar o desempenho por região.</p>
            </div>
        )}
        </div>
      </div>
    </div>
  );
};

// Sub-componentes customizados
const StatCard = ({ icon, title, value, color }) => (
  <div className="card border-0 shadow-sm rounded-4 h-100">
    <div className="card-body">
      <div className={`text-${color} mb-2`}>
        <div className={`bg-opacity-10 p-2 rounded-3 d-inline-block border border-opacity-25`} style={{ backgroundColor: `${color}15`, color: color }}>
          {icon}
        </div>
      </div>
      <div className="text-muted small fw-bold text-uppercase" style={{fontSize: '10px'}}>{title}</div>
      <h3 className="fw-bold m-0">{value}</h3>
    </div>
  </div>
);

const MiniCard = ({ title, value, theme, cor }) => (
  <div className={`p-3 rounded-3 border border-2 border-${theme} border-opacity-25 bg-${theme} bg-opacity-10 text-center h-100`} style={{ backgroundColor: `${cor}15`, color: cor }}>
    <div className={`text-${theme} small fw-bold text-uppercase mb-1`} style={{fontSize: '9px'}}>{title}</div>
    <div className="fw-bold text-dark">{value}</div>
  </div>
);

const ServiceRow = ({ icon, color, label, value, sub }) => (
  <div className="d-flex align-items-center gap-3 p-3 bg-light rounded border border-opacity-50">
    <div className={`bg-${color} text-white p-2 rounded shadow-sm`}>{icon}</div>
    <div className="flex-grow-1">
      <div className="text-muted small fw-bold text-uppercase" style={{fontSize: '9px'}}>{label}</div>
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-bold">{value}</span>
        <span className="text-muted small italic" style={{fontSize: '10px'}}>{sub}</span>
      </div>
    </div>
  </div>
);

export default Totalizador;